import InvestorEarningsCalculator from './investor-earnings-calculator';

export default InvestorEarningsCalculator;
